import { ArrowRightFromSquare } from "@gravity-ui/icons";
import { Flex, Icon, Skeleton, Text, User } from "@gravity-ui/uikit";
import classNames from "classnames";

import {
  TelegramInjectProps,
  useTelegramInject,
} from "./hooks/useTelegramInject";
import css from "./TelegramAuth.module.scss";

export const TelegramAuth = (props: TelegramInjectProps) => {
  const { ref, isLoading } = useTelegramInject(props);

  const username =
    props.user?.username || props.user?.firstName || "Пользователь";

  return (
    <div ref={ref}>
      {isLoading && <Skeleton style={{ height: 30 }} />}
      {props.user && (
        <button
          className={classNames(
            css.telegramUserButton,
            css[props.size || "medium"],
          )}
          style={{ borderRadius: props.radius ? props.radius : "" }}
        >
          <Flex alignItems={"center"} justifyContent={"space-between"} gap={4}>
            <Flex alignItems={"center"} gap={2} style={{ padding: 4 }}>
              <User
                avatar={{
                  text: username,
                  backgroundColor: "#e57979",
                  color: "white",
                  imgUrl: props.user.photoUrl,
                }}
                size="xs"
                name={
                  <Text variant="subheader-1" style={{ color: "white" }}>
                    {username}
                  </Text>
                }
              />
            </Flex>
            <div className={css.logout} onClick={props.onLogout}>
              <Icon data={ArrowRightFromSquare} />
            </div>
          </Flex>
        </button>
      )}
    </div>
  );
};
